// extracted by mini-css-extract-plugin
export default {"header":"styles_header__wL7S2","copyButton":"styles_copyButton__lFn1F","deleteButton":"styles_deleteButton__Jp87L"};